import {
    Component,
    Inject,
    ViewChild,
    AfterViewInit,
    ChangeDetectorRef,
    ChangeDetectionStrategy, OnInit
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Controller } from '@homeleite/domain';

@Component({
    selector: 'app-controller-details-dialog',
    templateUrl: './controller-details-dialog.component.html',
    styleUrls: ['./controller-details-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ControllerDetailsDialogComponent implements AfterViewInit, OnInit {
    entity: any;
    entityForEdit: Controller;
    isEditState: boolean;

    constructor(
        public dialogRef: MatDialogRef<ControllerDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { entity: Controller },
        private cdRef: ChangeDetectorRef
    ) {
        this.isEditState = !!this.data.entity;
    }

    ngOnInit() {
        if (this.isEditState) {
            this.entityForEdit = Controller.fromJson(JSON.parse(JSON.stringify(this.data.entity)));
        } else {
            this.entityForEdit = new Controller();
        }
    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

    onSave(formData: any) {
        this.dialogRef.close(formData);
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    get initials(): string {
        const name = (this.entityForEdit?.name || (this.isEditState ? 'C' : 'Novo')).trim();
        const parts = name.split(/\s+/).filter(Boolean);
        if (parts.length >= 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return name.slice(0, 2).toUpperCase();
    }
}
